import { type Atom, useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { useMemo } from "react";

export function useSelectAtom<In, Out>(
  atomIn: Atom<In>,
  map: (value: In) => Out,
  deps: unknown[] = [],
  equals: (a: Out, b: Out) => boolean = Object.is,
): Out {
  // biome-ignore lint/correctness/useExhaustiveDependencies: ...
  const atomToUse = useMemo(() => selectAtom(atomIn, map, equals), [atomIn, ...deps]);
  // useDevChangedDeps("useSelectAtom", {
  //   atomIn,
  //   ...Object.fromEntries(deps.map((a, i) => [String(i), a])),
  // });
  return useAtomValue(atomToUse);
}
